<script lang="ts" setup>
    import useMenu from "~/composables/use-menu.js";

    const menu: any = await useMenu('footer-menu');
    const contactDetails: any = await useAcfOptions('contact_details');
</script>

<template>
  <div class="container-fluid bg-secondary footer-menu">
    <div class="row">
      <div class="w-100 pt-3">
        <div class="container">
          <div class="row py-3">
            <template v-for="item in menu?.menuItems?.nodes">
              <div class="d-flex flex-column col-12 col-md-6 col-lg-3 footer-item">
                <a :href="item?.uri" class="text-primary text-uppercase">{{ item?.label }}</a>
                <template v-for="subItem in item?.childItems?.nodes">
                  <a :href="subItem?.uri" class="text-green-light mt-2">{{ subItem?.label }}</a>
                </template>
              </div>
            </template>
            <div class="d-flex flex-column col-12 col-md-6 col-lg-3 footer-item">
              <a href="/contact-us/" class="text-primary text-uppercase">Contact Us</a>
              <a :href="`tel:${contactDetails?.contact_details_number}`" class="text-green-light mt-2">{{ contactDetails?.contact_details_number }}</a>
              <a :href="`mailto:${contactDetails?.contact_details_email}`" class="text-green-light mt-2">{{ contactDetails?.contact_details_email }}</a>
              <p class="mt-4 text-green-light">{{ contactDetails?.contact_details_address }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <hr/>
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex flex-column align-items-start flex-md-row justify-content-md-between footer-item">
              <p class="text-uppercase">
                &copy; 2025 All rights reserved.<br/>
                <a href="https://mage2.com.au" target="_blank" class="text-primary"><small>Website by Mage2</small></a>
              </p>
              <a href="/privacy-policy/" class="text-uppercase text-primary">Privacy</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>